<template>
  <!-- <div class="background-wrapper"> 
    <div class="overlay"></div>
  <b-container class="mt-4" style="max-width: 800px;">
      <b-form @submit.prevent="guardarInventario" class="mb-5">
        <b-row class="mb-2 align-items-center">
          <b-col sm="3" class="text-left"><label>DNI</label></b-col>
          <b-col class="d-flex" sm="9"><b-form-input v-model="dni" type="number" required></b-form-input> <button type="button"
              class="btn btn-success" @click="validarSubSubCentro">Cargar</button> </b-col>
        </b-row>

        <b-row class="mb-2 align-items-center">
          <b-col sm="3" class="text-left"><label>TIENDA</label></b-col>
          <b-col sm="9">
            <div class="col-12">
              <multiselect class="tamaño quitar" v-model="codigoTienda" :options="listado" :custom-label="nameWithLang"
                track-by="idRuta" label="tieNombre" placeholder="--SELECCIONAR TIENDA--">
                <template #singleLabel="{ option }">
                  <strong>{{ option.tieNombre }}</strong>
                </template>
</multiselect>
<input v-model="codigoTienda" required
  style="opacity: 0; position: absolute; width: 1px; height: 1px; pointer-events: none;">
</div>
</b-col>
</b-row>

<b-row class="mb-2 align-items-center">
  <b-col sm="3" class="text-left"><label>LISTA DE LIBROS</label></b-col>
  <b-col sm="9">

    <div class="col-12">
      <multiselect class="tamaño quitar" v-model="codigoLibro" :options="libros" :custom-label="nameWithLang"
        track-by="parCorrelativo" label="parDescripcion" placeholder="--SELECCIONAR EL LIBRO--">
        <template #singleLabel="{ option }">
                  <strong>{{ option.parDescripcion }}</strong>
                </template>
      </multiselect>
      <input v-model="codigoLibro" required
        style="opacity: 0; position: absolute; width: 1px; height: 1px; pointer-events: none;">
    </div>
  </b-col>
</b-row>

<b-row class="mb-3 align-items-center">
  <b-col sm="3" class="text-left"><label>CANTIDAD</label></b-col>
  <b-col sm="9"><b-form-input type="number" v-model="cantidad" required></b-form-input></b-col>
</b-row>

<div class="text-right">
  <b-button type="submit" variant="outline-secondary">Registrar en Tabla</b-button>
</div>
</b-form>

<b-table bordered hover :items="registros" :fields="campos" head-variant="light">
  <template #empty>
          <div class="text-center">No hay registros</div>
        </template>
</b-table>
</b-container>
</div> -->

  <div class="background-wrapper">
    <div class="overlay"></div> <b-container class="py-4 main-content">
      <div class="form-card">
        <h3 class="text-center text-white mb-4">REGISTRO DE INVENTARIO</h3>
        <br>
        <b-form @submit.prevent="guardarInventario" class="px-3">


          <b-row class="mb-3 align-items-end">
            <b-col md="3">
              <label class="form-label text-white fw-semibold">DNI</label>
            </b-col>

            <b-col md="9">
              <div class="input-group">
                <b-form-input v-model="dni" type="number" required placeholder="Ingrese DNI"
                  class="custom-input"></b-form-input>

                <button type="button" class="btn btn-success" @click="validarSubSubCentro">
                  <i class="bi bi-search"></i>
                </button>
              </div>
            </b-col>
          </b-row>

         
          <b-row class="mb-3">
            <b-col md="3">
              <label class="form-label text-white fw-semibold">Tienda</label>
            </b-col>

            <b-col md="9">
              <multiselect v-model="codigoTienda" :options="listado" :custom-label="nameWithLang" track-by="idRuta"
                label="tieNombre" placeholder="Seleccionar tienda" />
              <input v-model="codigoTienda" required class="hidden-input">
            </b-col>
          </b-row>

        
          <b-row class="mb-3">
            <b-col md="3">
              <label class="form-label text-white fw-semibold">Libro</label>
            </b-col>

            <b-col md="9">
              <multiselect v-model="codigoLibro" :options="libros" :custom-label="nameWithLang"
                track-by="parCorrelativo" label="parDescripcion" placeholder="Seleccionar libro" />
              <input v-model="codigoLibro" required class="hidden-input">
            </b-col>
          </b-row>

       
          <b-row class="mb-4">
            <b-col md="3">
              <label class="form-label text-white fw-semibold">Cantidad</label>
            </b-col>

            <b-col md="9">
              <b-form-input type="number" v-model="cantidad" min="1" required placeholder="Cantidad"
                class="custom-input"></b-form-input>
            </b-col>
          </b-row>

          <div class="text-center mb-3">
            <b-button type="submit" variant="primary" class="btn-registrar px-3 py-2 ">
              <i class="bi bi-floppy "></i>
            </b-button>
          </div>

        </b-form>


        <div class="table-responsive border border-1 rounded-3 p-3 mb-0 ">

          <div class="row mb-3 justify-content-end mt-0">
            <div class="d-flex justify-content-end mt-0">
              <input class="input-group-text mt-2 buscar-estiloCuadrado" type="text" placeholder="NOM LIBRO"
                v-model="busquedaLibro" @input="busquedaLibro = busquedaLibro.replace(/\s+/g, ''); pag = 1"
                @keydown.space.prevent />
            </div>
          </div>


          <b-table bordered hover :items="paginatedRegistros" :fields="campos" head-variant="dark"
            class="bg-white custom-table text-justify">
            <template #empty>
              <div class="text-center">No hay registros</div>
            </template>
          </b-table>
        </div>

        <div v-if="registrosFiltrados.length > 0"
          class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">


          <button class="btn btn-outline-light btn-sm" @click="pag = 1" :disabled="pag === 1">
            <i class="bi bi-chevron-double-left"></i>
          </button>

          <button class="btn btn-outline-light btn-sm" @click="pag--" :disabled="pag === 1">
            <i class="bi bi-chevron-left"></i>
          </button>

          <span class="text-white mx-2" style="font-size: 0.9rem;">
            Página {{ pag }} de {{ totalPages }}
          </span>

          <button class="btn btn-outline-light btn-sm" @click="pag++" :disabled="pag === totalPages">
            <i class="bi bi-chevron-right"></i>
          </button>

          <button class="btn btn-outline-light btn-sm" @click="pag = totalPages" :disabled="pag === totalPages">
            <i class="bi bi-chevron-double-right"></i>
          </button>

        </div>

      </div>
    </b-container>
  </div>

</template>

<script>
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
export default {
  name: 'CopiasInventario',
  components: {
    Multiselect,
  },
  data() {
    return {
      // Campos que definen las columnas de la b-table
      campos: [
        { key: 'nombreLibro', label: 'NOM. LIBRO' },
        { key: 'invFecRegistro', label: 'FECHA / HORA' },
        { key: 'nombreTienda', label: 'TIENDA' },
        { key: 'invCantidad', label: 'CANTIDAD' },

      ],
      // Datos del formulario

      // Array donde se guardan los datos de la tabla
      registros: [],
      listado: [],
      libros: [],
      codigoTienda: "",
      codigoLibro: "",
      idTrabajador: "",
      cantidad: "",
      dni: "",

      tiendaKey: 0,
      libroKey: 0,

      pag: 1,
      NUM_RESULTS: 5,
      busquedaLibro: "",

    };
  },

  mounted() {

    this.axios.get("ParametroData/Parametro/7906").then((r) => {
      console.log(r.data);
      this.libros = r.data;
    });

  },

  computed: {

    registrosFiltrados() {
      if (!Array.isArray(this.registros)) return [];
      if (!this.busquedaLibro) return this.registros;

      const texto = this.busquedaLibro.toLowerCase();

      return this.registros.filter(r =>
        r.nombreLibro?.toLowerCase().includes(texto)
      );
    },


    paginatedRegistros() {
      const start = (this.pag - 1) * this.NUM_RESULTS;
      return this.registrosFiltrados.slice(start, start + this.NUM_RESULTS);
    },


    totalPages() {
      if (this.registrosFiltrados.length === 0) return 1;
      return Math.ceil(this.registrosFiltrados.length / this.NUM_RESULTS);
    }
  },


  methods: {


    async guardarInventario() {
      // 1. Preparamos el objeto con los nombres exactos del DTO de C#
      const nuevoInventario = {
        idTrabajador: this.idTrabajador, // Ejemplo: 10
        idRuta: this.codigoTienda.idRuta,             // Ejemplo: 5
        invCodLibro: this.codigoLibro.parCorrelativo,   // Ejemplo: "B001"
        invCantidad: parseInt(this.cantidad) // Asegurar que sea número
      };

      try {
        const response = await this.axios.post('Inventario/InsertarInventario', nuevoInventario);

        if (response.data.success) {
          this.listadoTrabajador(this.idTrabajador)
          this.limpiarFormulario()
          Swal.fire({
            position: "center",
            icon: "success",
            title: "SE REGISTRO",
            showConfirmButton: true,
            // timer: 1500,
          });
        }
      } catch (error) {
        console.error("Error al insertar:", error);
        Swal.fire({
          position: "center",
          icon: "error",
          title: "ERROR AL REGISTRAR",
          showConfirmButton: true,
          // timer: 1500,
        });
      }
    },

    validarSubSubCentro() {
      this.axios
        .get(
          `Asistencia/ValidarSubSubCentro?nroDeDocumento=${this.dni}`
        )
        .then((response) => {
          console.log(response)
          if (response.status === 200) {
            this.idTrabajador = response.data.id
            this.listadoTrabajador(response.data.id)
            this.getListadoRutas(response.data.id)
            console.log("si"); // Mostrar botón si el valor es correcto
          }

        })
        .catch((error) => {
          console.error("Error al validar SubSubCentro:", error);
          Swal.fire({
            position: "center",
            icon: "error",
            title: "ERROR DE DNI",
            showConfirmButton: true,
            // timer: 1500,
          });
        });
    },

    listadoTrabajador(idTrabajador) {
      this.axios.get(`inventario/InventarioXtrabajador?idTrabajador=${idTrabajador}`).then(r => {
        console.log("infomracion", r.data)
        this.registros = r.data
      })
    },

    getListadoRutas(id) {
      console.log(id)
      this.axios
        .get(
          `Inventario/ListarRutaPorTrabajador?idTrabajador=${id}`
        )
        .then((r) => {
          console.log("enrutado");
          this.listado = r.data
          console.log(r.data);
        });
    },

    nameWithLang(option) {
      if (!option) return "";
      // Retorna tieNombre para tiendas o parDescripcion para libros
      return option.tieNombre || option.parDescripcion || "";

    },

    limpiarFormulario() {
      // this.dni = "";
      // this.idTrabajador = "";
      // this.codigoTienda = ""; // Resetea el multiselect de tienda
      this.codigoLibro = "";  // Resetea el multiselect de libros
      this.cantidad = "";

      this.listado = []


    },




  },
};
</script>

<style scoped>
.table-bordered th,
.table-bordered td {
  border: 1px solid #000 !important;
}

label {
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.9rem;
}



/* 1. Fondo que cubre toda la pantalla */
.background-wrapper {
  background-image: url('../../assets/Corefo/fondoCorefo.jpg');
  /* Pon el link de la imagen de la biblioteca */
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  min-height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

/* 2. Capa oscura para que el texto resalte */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* Oscurece un 50% el fondo */
  z-index: 1;
}

/* 3. Contenedor del formulario (Efecto Vidrio) */
.main-content {
  position: relative;
  z-index: 2;
  max-width: 900px;
}

.form-card {
  background: rgba(255, 255, 255, 0.15);
  /* Blanco muy transparente */
  backdrop-filter: blur(10px);
  /* Desenfoque del fondo */
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
}

/* 4. Estilos de inputs y etiquetas */
label {
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.85rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.custom-input {
  background: rgba(255, 255, 255, 0.9) !important;
  border: none;
  border-radius: 8px;
}



/* Ajustes para la tabla */
.custom-table {
  border-radius: 10px;
  overflow: hidden;
  font-size: 0.9rem;
}

.hidden-input {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
  pointer-events: none;
}

/* Ajuste para celulares */
@media (max-width: 576px) {
  .form-card {
    padding: 15px;
    margin: 10px;
  }

  label {
    margin-bottom: 5px;
    display: block;
  }
}
</style>